import { ReactNode } from 'react'

type SettingsFormSectionDividerProps = {
  title: string
  description?: ReactNode
  className?: string
}

const SettingsFormSectionDivider = ({
  title,
  description,
  className = '',
}: SettingsFormSectionDividerProps) => (
  <div className={`flex min-h-[44px] flex-col justify-start gap-sm ${className}`}>
    <div className="flex select-none flex-col items-start justify-between gap-xs text-text-md text-gray-900">
      {title}
      {description && (
        <div className="flex select-none items-center justify-between gap-md pb-sm text-text-md text-gray-400">
          {description}
        </div>
      )}
    </div>
    <div className="w-full border-t border-t-gray-300" />
  </div>
)

export default SettingsFormSectionDivider
